import PropTypes from "prop-types";
import { VIEWER_ACCESS_DENIED_MESSAGE } from "../utils/constants";
import CustomToolTip from "./CustomTooltip";

const CustomToolTipWithPermission = ({
  title,
  permission,
  displayPermissionDeniedMessage = true,
  children,
  ...props
}) => {
  if (!title && permission) {
    return children;
  }

  const finalTitle =
    !permission && displayPermissionDeniedMessage
      ? VIEWER_ACCESS_DENIED_MESSAGE
      : title;
  return (
    <CustomToolTip title={finalTitle} {...props}>
      {children}
    </CustomToolTip>
  );
};

CustomToolTipWithPermission.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  permission: PropTypes.bool.isRequired,
  displayPermissionDeniedMessage: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default CustomToolTipWithPermission;
